<template>
    <div class="ml-2">
        <v-btn color="primary" @click="$emit('homologarAdjudicarItemLote')">Adjudicar/Homologar</v-btn>
    </div>
</template>

<script>
export default {
    name: 'BotaoHomologarAdjudicarItemLote'
}
</script>

<style scoped lang="stylus">

</style>